import type { InvoiceState } from '@allocab/allocab-invoice-service-types';

import {
  INVOICE_STATUS_COLORS,
  INVOICE_STATUS_LABELS,
  toInvoiceDisplayStatus,
  type InvoiceDisplayStatus,
} from './invoiceLabels';

/**
 * Accepte soit un `InvoiceState` back (cas liste — `InvoiceV2Output`), soit un
 * `InvoiceDisplayStatus` UI déjà mappé (cas détail facture alimenté depuis le
 * cache liste via `useExtranetInvoiceDetail`).
 */
type InvoiceStatusBadgeProps = { state: InvoiceState } | { displayStatus: InvoiceDisplayStatus };

export const InvoiceStatusBadge = (props: InvoiceStatusBadgeProps) => {
  const display: InvoiceDisplayStatus = 'state' in props ? toInvoiceDisplayStatus(props.state) : props.displayStatus;
  const tokens = INVOICE_STATUS_COLORS[display];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md text-xs font-medium px-2 py-0.5 ${tokens.bg} ${tokens.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${tokens.dot}`} aria-hidden />
      {INVOICE_STATUS_LABELS[display]}
    </span>
  );
};
